import React from "react";

export default function MSAccess_Str() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Str</h1>
      <p>This is the MSAccess_Str component generated from the SQL JSON.</p>
    </div>
  );
}
